import React from "react";

const AuthenticatingScreen = ({ message = "Authenticating..." }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background gap-6 animate-fade-in">
      {/* Logo or Brand */}
      <h1 className="mb-4 animate-pulse text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight bg-gradient-to-tr from-[rgb(230,200,50)] from-30% to-black to-70% bg-clip-text text-transparent">
        Lemonade Training
      </h1>

      {/* Status Message */}
      <div className="text-center max-w-[400px] px-4">
        <p className="text-lg text-muted-foreground mb-2 font-medium">{message}</p>
        <p className="text-sm text-muted-foreground/70">This may take a few seconds</p>
      </div>

      {/* Indeterminate Progress Bar */}
      <div className="w-full max-w-[400px] px-4">
        <div className="h-2 w-full rounded-lg bg-muted overflow-hidden">
          <div className="h-full w-1/3 bg-primary animate-indeterminate" />
        </div>
      </div>
    </div>
  );
};

export default AuthenticatingScreen;
